import { WashIcon } from "../../assets/icons/WashGuarantee";
import { useTranslate } from "@made-people/grease-translations";
import { useHundredWashes } from "../../hooks/use-hundred-washes";

export const HundredWashesSmallBlock = () => {
  const translate = useTranslate();
  const { show } = useHundredWashes();

  if (!show) return null;

  return (
    <div className="flex items-center gap-2">
      <WashIcon className="h-5 w-auto shrink-0" />
      <span className="text-body-sm uppercase font-medium leading-tight">
        {translate("100_Washes_Guarantee_Title")}
      </span>
    </div>
  );
};
